import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

// Components
import { Text, ColoredCountUp } from './..'

// Assets
import rightArrow from '../../assets/img/right-arrow.svg'

import styles from './ClickableTile.module.scss'

const ClickableTile = ({
  heading,
  value,
  prefix,
  suffix,
  formatter,
  subTitleComponent: SubTitleComponent = React.Fragment,
  className,
  onClick,
  ...restProps
}) => {
  return (
    <div
      role='button'
      tabIndex='0'
      className={classnames(styles.root, className)}
      onClick={onClick}
    >
      {heading && (
        <Text
          size='s'
          color='white'
          weight='semibold'
          transform='uppercase'
          letterSpacing='large'
        >
          {heading}
        </Text>
      )}
      <Text
        size='xl'
        letterSpacing='large'
        weight='regular'
        className={styles.currency}
      >
        <ColoredCountUp
          className={styles.countUp}
          value={value}
          prefix={prefix}
          suffix={suffix}
          formatter={formatter}
          {...restProps}
        />
      </Text>
      <img src={rightArrow} alt='right arrow' className={styles.arrow} />
      <SubTitleComponent />
    </div>
  )
}

ClickableTile.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  value: PropTypes.number,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  formatter: PropTypes.func,
  className: PropTypes.string,
  onClick: PropTypes.func,
  subTitleComponent: PropTypes.any.isRequired,
}

export default ClickableTile
